// extracted by mini-css-extract-plugin
var _1 = "raIxoFOyiC";
var _2 = "Na7k6tnYDp";
var _3 = "uru0KyHSX5";
var _4 = "UW4t_7k2Ux";
var _5 = "ban3io4oEt";
export { _1 as "close", _2 as "footer", _3 as "next", _4 as "prev", _5 as "root" }
